import { Link, Typography } from '@forgeglobal/design-framework';
import useStyles from './style';

// NonRMD
export const DefaultWhyNonRMD = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography>
        You will be required to provide supporting documentation to verify the
        value of your investment under following circumstances:
      </Typography>
      <ul className={classes.infoList}>
        <li>
          <Typography>
            Your{' '}
            <span className={classes.importantText}>
              investment value has either increased or decreased significantly
            </span>{' '}
            from the previous value on record
          </Typography>
        </li>
        <li>
          <Typography>
            This investment is included in an{' '}
            <span className={classes.importantText}>
              upcoming taxable event
            </span>{' '}
            (e.g. an in-kind distribution or Roth conversion), or will be in the
            next year.
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export const DefaultWhichNonRMD = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography>Examples of documents we accept include:</Typography>
      <ul className={classes.infoList}>
        <li>
          <Typography>
            a <span className={classes.importantText}>bank statement</span>
          </Typography>
        </li>
        <li>
          <Typography>
            an{' '}
            <span className={classes.importantText}>investment statement</span>
          </Typography>
        </li>
        <li>
          <Typography>
            other{' '}
            <span className={classes.importantText}>
              dated document with the reflected value
            </span>
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export const RealEstateWhichNonRMD = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography>Examples of documents we accept include:</Typography>
      <ul className={classes.infoList}>
        <li>
          <Typography>
            <span className={classes.importantText}>
              most recent tax assessment notice
            </span>{' '}
            or <span className={classes.importantText}>tax bill</span>{' '}
            representing the fair market value (exception if the account is
            inherited)
          </Typography>
        </li>
        <li>
          <Typography>
            <span className={classes.importantText}>
              a letter or other document signed by a real estate professional
            </span>{' '}
            specifying the current fair market value
          </Typography>
        </li>
        <li>
          <Typography>
            <span className={classes.importantText}>
              a certified appraisal provided by a licensed appraiser
            </span>
          </Typography>
        </li>
      </ul>
    </div>
  );
};

// RMD
interface DefaultWhichRMDProps {
  link: string;
}

export const DefaultWhichRMD = ({ link }: DefaultWhichRMDProps) => {
  const classes = useStyles();

  return (
    <div>
      <Typography>
        Examples of documentation include{' '}
        <span className={classes.importantText}>
          a letter or other document signed by a licensed professional - e.g.,
          attorneys, CPA&apos;s, and Financial Planners
        </span>{' '}
        - specifying the current fair market value.
      </Typography>
      <br />
      <Typography>
        <span>
          You can download a template <Link href={link}>here</Link> if you wish
          to use it.
        </span>
      </Typography>
    </div>
  );
};

export const RealEstateWhichRMD = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography>Examples of documentation include:</Typography>
      <ul className={classes.infoList}>
        <li>
          <Typography>
            <span className={classes.importantText}>
              a letter or other document signed by a real estate professional
            </span>{' '}
            specifying the current fair market value
          </Typography>
        </li>
        <li>
          <Typography>
            <span className={classes.importantText}>
              a certified appraisal provided by a licensed appraiser
            </span>
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export const DefaultWhyRMD = () => (
  <Typography>
    Because the amount of the minimum distribution you are required to take from
    your account (i.e. your RMD) is based on the total value of your account, we
    are required to verify the value of your investment by collecting supporting
    documentation from a qualified third party.
  </Typography>
);
